import { z } from 'zod';

export function getApiOrigin() {
  return z
    .string({
      required_error: 'PUBLIC_API_ORIGIN must be set in environment variables',
      invalid_type_error: 'PUBLIC_API_ORIGIN must be a string',
    })
    .parse(process.env.PUBLIC_API_ORIGIN);
}
